import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://neobroker.com';

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const setMeta = (attr, key, content) => {
  const el = upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute(attr, key);
    return m;
  });
  el.setAttribute('content', content);
};

// Per-page canonical / description / robots so Google never sees the homepage canonical on sub pages.
export const useSeo = ({ title, description, noindex = false, ready = true } = {}) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!ready) return undefined;
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    const url = `${SITE}${path}`;
    if (title) document.title = title;
    const canonical = upsert('link[rel="canonical"]', () => {
      const l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      return l;
    });
    canonical.setAttribute('href', url);
    setMeta('property', 'og:url', url);
    if (title) setMeta('property', 'og:title', title);
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
    }
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
    return () => {
      if (noindex) setMeta('name', 'robots', 'index, follow');
    };
  }, [pathname, title, description, noindex, ready]);
};
